<template>
  <div class="opple-ability-ui-com-timeRange">
    <el-time-picker
      v-model="startTime"
      format="HH:mm"
      :placeholder="$t('ifttt.timeStart')"
    />
    <el-time-picker
      v-model="endTime"
      format="HH:mm"
      :placeholder="$t('ifttt.timeEnd')"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      startTime: null,
      endTime: null
    }
  },

  computed: {
   
  },

  mounted() {
    console.log('mounted Time');
    
    this.setTime();
  },

  methods: {
    setTime() {
      const { DefaultValue } = this.item;

      if (!DefaultValue) return;

      const { startTime, endTime } =  this.parseTimeRangeDesc(Number(DefaultValue));
// console.log('startTime', startTime);

      this.startTime = startTime.toDate();
      this.endTime = endTime.toDate();
      
    },
    getData() {
      const { startTime, endTime } = this;
      const start = moment(startTime, "HH:mm");
      const sTime = start.hours() * 60 + start.minutes()
      const end = moment(endTime, "HH:mm");
      const eTime = end.hours() * 60 + end.minutes();
      const value = sTime << 16 | eTime;
      console.log('save time', startTime, endTime, value);
      return {
          Key: this.item.KeyId,
          Values: ['' + value]
        }
    },

    parseTimeRangeDesc(timeStamp) {
      const start = timeStamp >> 16;
      const end = timeStamp & 0xFFFF;
      console.log('start', timeStamp, start, end);
      
      const startTime = moment().hour(start / 60).minutes(start % 60);
      const endTime = moment().hour(end / 60).minutes(end % 60);

      return {
        startTime,
        endTime,
      };
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-com-timeRange {
  display: flex;
  justify-content: space-between;

  &>div {
    width: 48% !important;

    i:after {
      display: none !important;
    }
    i:before {
      display: none !important;
    }
  }
}
</style>
